import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { apiService } from '../../services/api';
import { useToast } from '../../hooks/use-toast';

const AdminClubAdmins = () => {
  const { toast } = useToast();
  const [admins, setAdmins] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    participant_id: '',
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [adminsRes, participantsRes] = await Promise.all([
        apiService.admin.getClubAdmins(),
        apiService.admin.getParticipants(),
      ]);
      setAdmins(adminsRes.data || []);
      setParticipants(participantsRes.data || []);
    } catch (error) {
      toast({ title: 'Error', description: 'Gagal memuat admin klub', variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await apiService.admin.createClubAdmin(formData);
      toast({ title: 'Berhasil', description: 'Admin klub berhasil dibuat' });
      setFormData({ username: '', email: '', password: '', participant_id: '' });
      loadData();
    } catch (error) {
      toast({ title: 'Error', description: error.response?.data?.detail || 'Gagal membuat admin klub', variant: 'destructive' });
    }
  };

  const handleDelete = async (adminId) => {
    if (!window.confirm('Hapus admin klub ini?')) return;
    try {
      await apiService.admin.deleteClubAdmin(adminId);
      toast({ title: 'Berhasil', description: 'Admin klub berhasil dihapus' });
      loadData();
    } catch (error) {
      toast({ title: 'Error', description: error.response?.data?.detail || 'Gagal menghapus admin klub', variant: 'destructive' });
    }
  };

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Kelola Admin Klub</h2>
          <p className="text-gray-600">Setiap tim dapat memiliki satu admin klub yang hanya bisa mengakses timnya sendiri.</p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-4">Tambah Admin Klub</h3>
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input type="text" placeholder="Username" value={formData.username} onChange={(e) => setFormData({ ...formData, username: e.target.value })} className="w-full px-4 py-2 border rounded-md" required />
            <input type="email" placeholder="Email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} className="w-full px-4 py-2 border rounded-md" required />
            <input type="password" placeholder="Password awal" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} className="w-full px-4 py-2 border rounded-md" required minLength={6} />
            <select value={formData.participant_id} onChange={(e) => setFormData({ ...formData, participant_id: e.target.value })} className="w-full px-4 py-2 border rounded-md" required>
              <option value="">Pilih Tim</option>
              {participants.map((participant) => (
                <option key={participant.id} value={participant.id}>{participant.name}</option>
              ))}
            </select>
            <button type="submit" className="md:col-span-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md">Buat Admin Klub</button>
          </form>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-4">Daftar Admin Klub</h3>
          {loading ? (
            <div className="text-gray-600">Memuat...</div>
          ) : admins.length === 0 ? (
            <div className="text-gray-500">Belum ada admin klub.</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left border-b">
                    <th className="py-2">Username</th>
                    <th className="py-2">Email</th>
                    <th className="py-2">Klub</th>
                    <th className="py-2">Status</th>
                    <th className="py-2">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {admins.map((admin) => (
                    <tr key={admin.id} className="border-b">
                      <td className="py-2">{admin.username}</td>
                      <td className="py-2">{admin.email}</td>
                      <td className="py-2">{admin.participant_name || '-'}</td>
                      <td className="py-2">{admin.is_active ? 'Aktif' : 'Nonaktif'}</td>
                      <td className="py-2">
                        <button type="button" onClick={() => handleDelete(admin.id)} className="text-red-600 hover:text-red-800">Hapus</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminClubAdmins;